import { render, staticRenderFns } from "./CreatorFlowerMarket.vue?vue&type=template&id=45a8f80a&scoped=true"
import script from "./CreatorFlowerMarket.vue?vue&type=script&lang=js"
export * from "./CreatorFlowerMarket.vue?vue&type=script&lang=js"
import style0 from "./CreatorFlowerMarket.vue?vue&type=style&index=0&id=45a8f80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8f80a",
  null
  
)

export default component.exports